import { render, staticRenderFns } from "./UrgencyQueue.vue?vue&type=template&id=563fe9dd&scoped=true&lang=pug"
import script from "./UrgencyQueue.vue?vue&type=script&lang=js"
export * from "./UrgencyQueue.vue?vue&type=script&lang=js"
import style0 from "./UrgencyQueue.vue?vue&type=style&index=0&id=563fe9dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fe9dd",
  null
  
)

export default component.exports